var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMusculo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58674 37.3169C3.81623 40.5015 13.5076 43.0033 18.0849 37.0407C23.0371 39.4084 31.2053 38.6744 37.8543 34.965C38.7777 34.4501 39.6537 33.7989 40.1884 32.8854C41.3978 30.8235 41.4274 27.9626 39.2216 23.7422C35.542 14.5576 28.9265 6.49758 26.2551 3.25582C25.7066 2.75466 22.2065 2.04436 20.0737 1.36168C19.1306 1.07163 17.3766 0.8763 15.2774 3.64254C14.281 4.95463 9.76086 8.17468 15.4964 10.3411C16.3842 10.568 17.0392 10.9843 21.0918 10.2425C21.6205 10.1517 22.9385 10.2425 23.8678 11.8742L25.8072 14.6483C25.9895 14.9053 26.1048 15.2037 26.1426 15.5165C26.482 18.4761 26.4701 22.1776 28.1196 24.052C25.5724 22.2111 18.9175 20.023 13.9022 26.248M1.55518 22.7853C3.81271 20.7725 6.691 19.5929 9.7117 19.4425C12.7324 19.2921 15.7136 20.18 18.1599 21.9585",
    stroke: "#4C4C4C",
    strokeWidth: 1.29361,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusculo);
export default __webpack_public_path__ + "static/media/icon_musculo.a675412130e147641ca17b6eb1b58be3.svg";
export { ForwardRef as ReactComponent };